import { isMobile } from '../constants/devices.constants';
import { SIDE_PANEL_BANNER_HEIGHT_PROPERTY } from '../constants/nav.constants';
// Measures the banner that is visible at the current width and stores it for the
// mobile nav and inline cart. Call after the panel's open class is on <html> so a
// scroll-hidden banner is expanded before it is measured.
export function updateSidePanelBannerOffset() {
    const bannerSelector = isMobile() ? '.global-banner--mobile' : '.global-banner--desktop';
    const banner = document.querySelector(bannerSelector);
    const bannerHeight = banner?.classList.contains('global-banner--has-initial-banners')
        ? banner.offsetHeight
        : 0;
    document.documentElement.style.setProperty(SIDE_PANEL_BANNER_HEIGHT_PROPERTY, `${bannerHeight}px`);
}
